import type { Requests } from "../common/request.common";
import type { MarketingInvoiceResponseTypes } from "../common/response.common";
import { post } from "./common";

export const marketingInvoice = {
    record(data: typeof Requests.MarketingInvoice.Record.Input) {
        return post<typeof data, MarketingInvoiceResponseTypes.Record>(
            `/marketing-invoice/record`,
            data,
        );
    },
};
